export const MENUITEMS = [
  {
    Items: [
      {
        path: "/superadmin/dashboard",
        icon: "fa fa-home",
        type: "link",
        active: true,
        selected: true,
        title: "Dashboard",
      },
      
    
      // {
      //   title: "Staff",
      //   icon: "fa fa-user",
      //   type: "sub",
      //   active: false,
      //   selected: false,
      //   children: [
      //     {
      //       path: "/staff/addstaff",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "Add staff",
      //     },

      //     {
      //       path: "/staff/allstaff",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "All Staff",
      //     },
      //     // {
      //     //   path: "/staff/editstaff",
      //     //   type: "link",
      //     //   active: false,
      //     //   selected: false,
      //     //   title: "Edit Staff",
      //     // },
          
          
      //   ],
      // },
      {
        title: "Group",
        icon: "fa fa-address-book sidemenu-icon menu-icon",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/group/addgroup",
            type: "link",
            active: false,
            selected: false,
            title: "Add Group",
          },
          {
            path: "/group/allgroup",
            type: "link",
            active: false,
            selected: false,
            title: "All Group",
          },
         
          // {
          //   path: "/timetable/alltimetable",
          //   type: "link",
          //   active: false,
          //   selected: false,
          //   title: "Edit Group",
          // },
          
        ],
      },
     
      {
        title: "Members",
        icon: "fa fa-users",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/member/addmember",
            type: "link",
            active: false,
            selected: false,
            title: "Add Member",
          },
          {
            path: "/member/allmembers",
            type: "link",
            active: false,
            selected: false,
            title: "All Members",
          },

         

        ],
      },
      {
        title: "Loan",
        icon: "fa fa-credit-card",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/loan/loanapproval",
            type: "link",
            active: false,
            selected: false,
            title: "Pending Loan",
          },
          {
            path: "/loan/allloan",
            type: "link",
            active: false,
            selected: false,
            title: "All Loans",
          },
          
        ],
      },
      {
        title: "Collection",
        icon: "fa fa-money",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/collection/addcollection",
            type: "link",
            active: false,
            selected: false,
            title: "Recovery Posting"
            // title: "Add Collection",
          },
          {
            path: "/collection/allcollection",
            type: "link",
            active: false,
            selected: false,
            title: "All Collection",
          },
         
        ],
      },
      

      // {
      //   // path: "/superadmin/reports",
      //   icon: "fa fa-download",
      //   type: "sub",
      //   active: false,
      //   selected: false,
      //   title: "Reports",
      //   children: [
      //     {
      //       path: "/reports/dailycollectionsheet",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "Daily Collection Sheet",
      //     },
      //     {
      //       path: "/reports/collectionsheet",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "Weekly Collection Sheet",
      //     },
      //     {
      //       path: "/reports/topcollectionsheet",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "Top Collection Sheet",
      //     },
      //     // {
      //     //   path: "/reports/pendingcollectionsheet",
      //     //   type: "link",
      //     //   active: false,
      //     //   selected: false,
      //     //   title: "Pending Collection Sheet",
      //     // },
      //     {
      //       path: "/reports/summary",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "Summary Report",
      //     },
      //     {
      //       path: "/reports/loandisbursement",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "Loan Disbursement",
      //     },
      //     {
      //       path: "/reports/outstanding",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "Outstanding Report",
      //     },
      //     {
      //       path: "/reports/denomination",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "Denomination",
      //     },
          
      //   ],
      // },
      {
        path: "/attendance/clockinout",
        icon: "fa fa-clock-o",
        type: "link",
        active: false,
        selected: false,
        title: "Clock In / Out",
      },
      {
        path: "/payslip/mypayslip",
        icon: "fa fa-file-text",
        type: "link",
        active: false,
        selected: false,
        title: "My Payslips",
      },

    ],
  },
];
